import { Menu } from '@edikk-edikk/icon/Menu';
import { FC } from 'react';
import { SvgIcon } from '@edikk-edikk/svg-icon';
import { Button, ButtonContentWithLoader, ButtonVariant } from '@edikk-edikk/country-layout-black';
import { useMenuContext } from '#baseMenu/hooks';

const ButtonOpen: FC = () => {
  const { open, isOpen, isContentLoadInProcess } = useMenuContext();

  if (isOpen) {
    return null;
  }

  return (
    <Button
      variant={ButtonVariant.black65}
      circle
      onClick={open}
      additionalClassName="flex-shrink-0"
      aria-label="Open menu"
    >
      <ButtonContentWithLoader
        isLoading={isContentLoadInProcess}
        content={<SvgIcon Component={Menu} width={14} height={14} />}
      />
    </Button>
  );
};

export { ButtonOpen };
